import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: '/public-endpoint',
      iconClass: 'fas fa-file-alt',
      order: 2,
      name: '::Menu:PublicEndpoints',
      layout: eLayoutType.application,
      requiredPolicy: 'SestekAI.PublicEndpoints.Create',
    },
  ]);
};

export const PUBLICENDPOINTS_PUBLİCENDPOINT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
